import { h } from "preact";
import { observer } from "mobx-react";
import { translate, t } from "../../I18n";
function CartHeader(props) {
    const { isClearVisible, onClose, onClear } = props;
    const handleClose = (event) => {
        event.preventDefault();
        onClose();
    };
    const handleClear = (event) => {
        event.preventDefault();
        if (window.confirm(translate(t.restaurants.widgets.cart.clear_confirmation))) {
            onClear();
        }
    };
    return (h("div", { class: "modal-header" },
        h("a", { onClick: handleClose, class: "close-cart", href: "#", "data-ga-action": "Close cart (X button clicks)", title: translate(t.restaurants.widgets.cart.hide_and_continue), "data-testid": "cart/closeCart" }, "\u00D7"),
        h("h4", { class: "modal-title", id: "cart-title" }, translate(t.restaurants.widgets.cart.name)),
        " ",
        isClearVisible && (h("a", { onClick: handleClear, href: "#", class: "clear-cart" }, translate(t.restaurants.widgets.cart.clear)))));
}
export default observer(CartHeader);
